import { render } from "./ArticlesFilters.vue?vue&type=template&id=3a8f87e2&ts=true"
import script from "./ArticlesFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticlesFilters.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/ArticlesFilters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a8f87e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a8f87e2', __exports__)) {
    api.reload('3a8f87e2', __exports__)
  }
  
  module.hot.accept("./ArticlesFilters.vue?vue&type=template&id=3a8f87e2&ts=true", () => {
    api.rerender('3a8f87e2', render)
  })

}


export default __exports__